
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/until-the-end-of-the-internet",
      function () {
        return require("private-next-pages/terms/until-the-end-of-the-internet.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/until-the-end-of-the-internet"])
      });
    }
  